import React from 'react';
import { useAuthChat } from '../../hooks/useAuthChat';
import { useChatSync } from '../../hooks/useChatSync';
import { useChatPersistenceLoader } from '../../hooks/useChatPersistenceLoader';

/**
 * Componente que integra la autenticación con el chat y la sincronización entre pestañas
 * Se encarga de limpiar automáticamente los mensajes cuando el usuario cierra sesión
 * y mantiene sincronizados los mensajes entre pestañas
 */
export const AuthChatIntegration = () => {
  // Hook de autenticación - limpia mensajes en logout
  useAuthChat();
  
  // Hook de sincronización - mantiene mensajes sincronizados entre pestañas
  useChatSync();
  
  // Hook de carga de persistencia - fuerza la carga de mensajes en nuevas pestañas
  useChatPersistenceLoader();
  
  return null;
};

export default AuthChatIntegration;
